import { ErpIntegration } from '@/types/erp';
import { TypedDocumentNode, gql } from '@apollo/client';

export type GetErpIntegrationQueryType = {
  lager_asteria_erp_by_pk: Pick<
    ErpIntegration,
    'isOnboarded' | 'integration_id'
  >;
};

export type GetErpIntegrationQueryVariablesType = {
  uid: string;
};

export const getErpIntegrationQuery = gql`
  query getErpIntegrationQuery($uid: String!) {
    lager_asteria_erp_by_pk(uid: $uid) {
      isOnboarded
      integration_id
    }
  }
` as TypedDocumentNode<
  GetErpIntegrationQueryType,
  GetErpIntegrationQueryVariablesType
>;
